/*global VeloxWebView*/


var extension = {} ;
extension.name = "algae-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "DESALGINE"     : { FR: true, DE: true, ES: true, GB: false},  
    "DESALGINE_JET" : { FR: true, DE: true, ES: true, GB: true},  
    "X100"          : { FR: true, DE: false,ES: true, GB: false},   
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_algae."+p)
        } ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var algaeEl = view.viewRootEl.querySelector('[data-field-def="pool.p_algae"]');
        if(algaeEl){
            view.on("render", function(){
                algaeEl.setOptions(computeOptions()) ;
            }) ;
        }   
    }) ;
} ;




module.exports = extension ;